module.exports = __webpack_public_path__ + "static/img/小米15Pro.c45c0466.png";